import { useEffect, useState } from "react";
import Button from "../../design/Button";
import GModal from "../../design/components/GModal";
import { CustomInput } from "../../design/components/customComponents";

const CreateEditApiKeyModal = ({
  mode,
  visible,
  onClose,
  onSave,
  curApiKeyName = "",
  isLoading,
}) => {
  const [apiKeyName, setApiKeyName] = useState({
    value: curApiKeyName,
    error: null,
  });

  const handleCancel = () => {
    setApiKeyName({ value: "", error: null });
    onClose();
  };

  useEffect(() => {
    if (visible && mode === "edit") {
      setApiKeyName({ value: curApiKeyName || "", error: null });
    } else {
      setApiKeyName({ value: "", error: null });
    }
  }, [visible, mode]);

  return (
    <GModal
      heading={mode === "create" ? "Create API key" : "Rename API key"}
      visible={visible}
      closeModal={handleCancel}
      noScrollbar={true}
      bottomButtons={[
        <Button
          buttonText="Cancel"
          onClick={handleCancel}
          variant="outlined"
          hierarchy="white"
        />,
        <Button
          buttonText={mode === "create" ? "Create" : "Save"}
          onClick={() => onSave(apiKeyName.value)}
          variant="contained"
          hierarchy="green"
          disabled={
            !apiKeyName.value?.trim() ||
            (mode === "edit" && apiKeyName.value === curApiKeyName)
          }
          isLoading={isLoading}
        />,
      ]}
      bottomButtonsStyle={{ border: "none", paddingTop: 0 }}
      bodyWrapperStyle={{ paddingRight: 0 }}
      body={
        <div>
          <CustomInput
            label="Key name"
            value={apiKeyName}
            handleChange={(e) =>
              setApiKeyName((prev) => ({ ...prev, value: e.target.value }))
            }
            handleFocus={() =>
              setApiKeyName((prev) => ({ ...prev, error: null }))
            }
            name="api-key-name"
            type="text"
            placeholder="eg. Production integration"
            style={{ margin: 0 }}
          />
        </div>
      }
    />
  );
};

export default CreateEditApiKeyModal;
